export default __webpack_public_path__ + "static/media/238.64c0c7f0.png";